module.exports = __webpack_public_path__ + "img/icon_sm_lpsmjgcx.08b4583c.png";